import getSaleableCombinedProductIds from '../get-saleable-combined-product-ids';
import getSaleableProductIds from '../get-saleable-product-ids';

const isSaleableProductId = (productId?: string | null) => {
  if (!productId) return false;

  const productIds = [...getSaleableProductIds(), ...getSaleableCombinedProductIds()];

  return new Set(productIds).has(productId);
};

export default isSaleableProductId;
